export const LOGIN_STATES = {
  DEFAULT: "default",
  INVALID_CREDENTIALS: "invalid_credentials",
  ACCOUNT_BLOCKED: "account_blocked",
  ACCOUNT_DISABLED: "account_disabled",
  NOT_ACTIVATED: "not_activated",
  CODE_STEP: "code_step",
  WRONG_CODE: "wrong_code",
  TOO_MANY_TRIES: "too_many_tries",
  TICKET_EXPIRED: "ticket_expired",
  CODE_SEND_FAILED: "code_send_failed",
  SOMETHING_WRONG: "something_wrong",
} as const;

export type LoginState = (typeof LOGIN_STATES)[keyof typeof LOGIN_STATES];
